import type { IconData } from '@stacksjs/iconify-core'

export const ipadTabletScreen: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M8.248 6.463c-2.55.177-4.539 2.081-4.762 4.627C3.24 13.88 3 18.115 3 24s.24 10.121.486 12.91c.223 2.546 2.212 4.45 4.762 4.627c3.227.225 8.38.463 15.752.463s12.525-.238 15.752-.463c2.55-.177 4.539-2.081 4.762-4.627C44.76 34.12 45 29.885 45 24s-.24-10.121-.486-12.91c-.223-2.546-2.212-4.45-4.762-4.627C36.525 6.238 31.372 6 24 6s-12.525.238-15.752.463M15 35h18\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default ipadTabletScreen
